const I18N_CHANNEL_NAME = 'i18n_channel';

export const MESSAGE_TYPE = 'LANGUAGE_CHANGED';

const channel = new BroadcastChannel(I18N_CHANNEL_NAME);

/** listener for reload events */
export function onTranslationReload(callback: (lang: string) => void) {
  channel.onmessage = (event) => {
    if (event.data?.type === MESSAGE_TYPE) {
      callback(event.data?.language!);
    }
  };
}

/** Call reload in all workspaces */
export function broadcastTranslationReload(language: string) {
  channel.postMessage({ type: MESSAGE_TYPE, language });
}